import * as z from "zod";
import {BelongToTaxAccountantResModel} from "./BelongToTaxAccountantResModel";

const schema = z.object({
	id: z.string(),
	manualUpdateDate: z.string().nullable(),
	affiliation: z.string().nullable(),
	name: z.string().nullable(),
	representativeName: z.string().nullable(),
	telephone: z.string().nullable(),
	fax: z.string().nullable(),
	address: z.string().nullable(),
	homepageUrl: z.string().nullable(),
	branchCount: z.number().nullable().default(0),
	registeredTaxAccountantCont: z.number().nullable().default(0),
	unregisteredTaxAccountantCont: z.number().nullable().default(0),
	etc: z.string().nullable(),
	familyWorked: z.boolean().nullable(),
	taxAccountants: z.array(BelongToTaxAccountantResModel.model).nullable().default([])
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxCorporationDetailResModel = {schema, model};
export type ITaxCorporationDetailResModel = z.infer<typeof TaxCorporationDetailResModel.model>;

export const DEFAULT_TAX_CORPORATION_RES: ITaxCorporationDetailResModel = {
	id: "",
	manualUpdateDate: "",
	affiliation: "",
	name: "",
	representativeName: "",
	telephone: "",
	fax: "",
	address: "",
	homepageUrl: "",
	branchCount: 0,
	registeredTaxAccountantCont: 0,
	unregisteredTaxAccountantCont: 0,
	etc: "",
	familyWorked: false,
	taxAccountants: []
};
